import { Observable } from 'rxjs'

import { request, parseAPIError, DownloadRequest } from '../../common/api'

import * as actionTypes from './actionTypes'
import * as actionCreators from './actionCreators'
import * as tableModelActionTypes from '../../common/table/actionTypes'
import { resolveModelState } from '../../common/table/helpers'

// Fetch

const fetchReportVehicleFuelingsEpic = (action$, store) => {
    const tableIdentifier = 'report_vehicle_fuelings'

    return action$
        .ofType(actionTypes.FETCH, tableModelActionTypes.CONFIGURATION_CHANGED)
        .filter(action => action.type !== tableModelActionTypes.CONFIGURATION_CHANGED || action.payload.tableIdentifier === tableIdentifier)
        .switchMap(action => {
            const modelState = resolveModelState(tableIdentifier, store.getState(), action)

            return Observable.concat(
                Observable.of({
                    type: actionTypes.FETCH_STARTED,
                }),
                request({
                    method: 'POST',
                    path: `report-vehicle-fuelings`,
                    body: {
                        filters: modelState.get('filters').toJS(),
                    },
                })
                    .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportVehicleFuelingsFulfilled(ajaxResponse.response)))
                    .catch(error => Observable.of(actionCreators.fetchReportVehicleFuelingsRejected(parseAPIError(error))))
                    .takeUntil(action$.ofType(actionTypes.FETCH_CANCELLED, actionTypes.FETCH))
            )
        })
}

// Export

const exportReportVehicleFuelingsEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT).switchMap(action => {
        const filters = JSON.stringify(action.payload)
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-vehicle-fuelings/export?filters=${filters}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_FULFILLED,
            })
        )
    })

// Fetch details

const fetchReportVehicleFuelingDetailsEpic = (action$, store) =>
    action$.ofType(actionTypes.FETCH_DETAILS).switchMap(action => {
        const tableIdentifier = 'report_vehicle_fuelings'
        const modelState = resolveModelState(tableIdentifier, store.getState(), action)

        return Observable.concat(
            Observable.of({
                type: actionTypes.FETCH_DETAILS_STARTED,
            }),
            request({
                method: 'POST',
                path: `report-vehicle-fuelings/details`,
                body: {
                    vehicle_id: action.payload.vehicleId,
                    date_from: action.payload.dateFrom,
                    date_to: action.payload.dateTo,
                    filters: modelState.get('filters').toJS(),
                },
            })
                .switchMap(ajaxResponse => Observable.of(actionCreators.fetchReportVehicleFuelingDetailsFulfilled(ajaxResponse.response)))
                .catch(error => Observable.of(actionCreators.fetchReportVehicleFuelingDetailsRejected(parseAPIError(error))))
                .takeUntil(action$.ofType(actionTypes.FETCH_DETAILS_CANCELLED))
        )
    })

// Export details

const exportReportVehicleFuelingDetailsEpic = (action$, store) =>
    action$.ofType(actionTypes.EXPORT_DETAILS).switchMap(action => {
        const token = store.getState().auth.get('accessToken')

        new DownloadRequest({
            url: `report-vehicle-fuelings/details/export?vehicle_id=${action.payload.vehicleId}&date_from=${action.payload.dateFrom}&date_to=${action.payload.dateTo}&filters=${JSON.stringify({ ...action.payload.filters })}&token=${token}`,
        }).run()

        return Observable.concat(
            Observable.of({
                type: actionTypes.EXPORT_DETAILS_FULFILLED,
            })
        )
    })

export default [
    fetchReportVehicleFuelingsEpic,
    exportReportVehicleFuelingsEpic,
    fetchReportVehicleFuelingDetailsEpic,
    exportReportVehicleFuelingDetailsEpic,
]
